import React from "react";

import { TextElementNova } from "@/components/ui-kit/TextElementNova/TextElementNova";
import { BenefitsItem } from "@/data/subscription/data_headspace";
import { cn } from "@/utils/general";

interface SubscriptionIncludesModalProps {
  items: BenefitsItem[];
}

const SubscriptionIncludesModal: React.FC<SubscriptionIncludesModalProps> = ({ items }) => {
  return (
    <div
      className={cn(
        "flex flex-col xl:flex-row",
        "border border-nova-transparency-black-20 rounded"
      )}
    >
      {items.map((item, index) => {
        const Icon = item.image;
        return (
          <div
            key={item.modalHeading}
            className={cn(
              "w-full",
              "xl:w-1/3",
              "p-4 md:p-6",
              index + 1 !== items.length
                ? "border-b xl:border-r xl:border-b-0 border-nova-transparency-black-20"
                : ""
            )}
          >
            <div
              className={cn(
                "flex mb-4 md:mb-6",
                "flex-row xl:flex-col",
                "items-center xl:items-start"
              )}
            >
              <div className={cn("w-8 h-8", "mr-4", "xl:mr-0", "xl:mb-4")}>
                <Icon width="100%" height="100%" className={`w-8 h-8`} />
              </div>
              <div className="flex-1">
                <TextElementNova text={item.modalHeading} className="Body-30-Dia-Strong" />
              </div>
            </div>
            <TextElementNova text={item.modalText} className="Body-20-Dia-Normal" />
          </div>
        );
      })}
    </div>
  );
};

export default SubscriptionIncludesModal;
